import { FC } from 'react';

type Props = {
	className?: string;
};

const PackageOpenIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.37328 6.89138C4.35216 6.90385 4.24076 6.98705 4.10615 7.08896C4.36012 7.25758 4.77948 7.46272 5.38581 7.75112L7.53474 8.7732C8.9079 9.42629 9.44072 9.66596 10.0005 9.66596C10.5604 9.66596 11.0932 9.42629 12.4663 8.7732L14.6152 7.75112C15.2216 7.46272 15.6409 7.25758 15.8949 7.08895C15.7603 6.98705 15.6489 6.90385 15.6278 6.89138C15.3935 6.75301 15.0195 6.59302 14.4229 6.34063C14.0651 6.18931 13.9131 5.8087 14.0832 5.49054C14.2534 5.17237 14.6813 5.03713 15.039 5.18846L15.0877 5.20902C15.6208 5.43454 16.0907 5.63325 16.4212 5.82846C16.7492 6.02213 17.1729 6.34566 17.1729 6.87934V13.833C17.1729 14.6611 16.5777 15.2159 15.8349 15.6686C15.0856 16.1253 13.8265 16.6656 12.434 17.263C11.3915 17.7107 10.7173 18.0002 10.0005 18.0002C9.28381 18.0002 8.6096 17.7106 7.56708 17.263C6.17461 16.6656 4.91549 16.1253 4.16617 15.6686C3.42341 15.2159 2.82812 14.6611 2.82812 13.833V6.87934C2.82812 6.34566 3.25185 6.02213 3.57984 5.82846C3.91042 5.63324 4.38026 5.43452 4.91349 5.209L4.96206 5.18846C5.31978 5.03713 5.74769 5.17237 5.91784 5.49054C6.08798 5.8087 5.93592 6.18931 5.5782 6.34064C4.9816 6.59302 4.60761 6.75301 4.37328 6.89138ZM6.06811 10.5595C5.79294 10.4287 5.46377 10.5456 5.33289 10.8208C5.20201 11.096 5.31898 11.4252 5.59415 11.556L7.06091 12.2536C7.33609 12.3845 7.66525 12.2675 7.79613 11.9924C7.92701 11.7172 7.81004 11.388 7.53487 11.2571L6.06811 10.5595Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.0024 2C10.4087 2 10.7381 2.32936 10.7381 2.73563V4.2069C10.7381 4.61317 10.4087 4.94253 10.0024 4.94253C9.59613 4.94253 9.26679 4.61317 9.26679 4.2069V2.73563C9.26679 2.32936 9.59613 2 10.0024 2ZM6.61852 2.88276C6.94354 2.63899 7.40463 2.70486 7.6484 3.02988L8.75185 4.50115C8.99564 4.82617 8.92972 5.28727 8.60472 5.53103C8.2797 5.7748 7.8186 5.70893 7.57484 5.38391L6.47139 3.91264C6.22762 3.58762 6.29349 3.12652 6.61852 2.88276ZM13.3863 2.88276C13.7113 3.12652 13.7772 3.58762 13.5335 3.91264L12.43 5.38391C12.1862 5.70893 11.7251 5.7748 11.4001 5.53103C11.0751 5.28727 11.0092 4.82617 11.253 4.50115L12.3564 3.02988C12.6002 2.70486 13.0613 2.63899 13.3863 2.88276Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default PackageOpenIconSolid;
